import React from 'react';
import { Map, TileLayer, MapProps } from 'react-leaflet';
import styled from 'styled-components';
import { LatLngBounds, LatLng } from 'leaflet';
import { Colors } from '@inplayer-org/inplayer-ui';

const bounds = new LatLngBounds(new LatLng(-57.98155760646617, -180), new LatLng(89.99346179538875, 180));

export const CustomMap = ({ center, zoom, minZoom, maxBoundsViscosity, attributionControl, children }: MapProps) => (
  <StyledMap
    center={center}
    zoom={zoom}
    minZoom={minZoom}
    maxBoundsViscosity={maxBoundsViscosity}
    maxBounds={bounds}
    attributionControl={attributionControl}
  >
    <TileLayer
      noWrap
      url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
    />
    {children}
  </StyledMap>
);

export const StyledMap = styled(Map)<MapProps>`
  width: 100%;
  height: 360px;
  background-color: white;
  display: grid;
  place-content: center;

  .leaflet-pane {
    z-index: 0;
  }

  .leaflet-top,
  .leaflet-bottom {
    z-index: 0;
  }

  .info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: ${Colors.white};
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
  .info h4 {
    margin: 0 0 5px;
    color: ${Colors.fontDarkGray};
  }

  .legend {
    line-height: 18px;
    color: ${Colors.fontGray};
  }
  .legend i {
    width: 18px;
    height: 18px;
    float: left;
    margin-right: 8px;
    opacity: 0.7;
  }
`;
